import { Option, Schema as S } from "effect";
import * as AsyncData from "foldkit/asyncData";
import { Field } from "foldkit/fieldValidation";

import { apiData } from "../../api/asyncData";
import { Entry, EntryHistoryEntry } from "../../api/schemas/entries";
import { RecordSummary } from "../../api/schemas/records";
import * as Attributes from "../../widgets/attributes";
import * as Tags from "../../widgets/tags";

export const Tab = S.Literals(["content", "history"]);
export type Tab = typeof Tab.Type;

export const History = S.Struct({
	items: S.Array(EntryHistoryEntry),
	nextCursor: S.Option(S.Number),
});
export type History = typeof History.Type;

export const AttributeRow = Attributes.Row;
export type AttributeRow = Attributes.Row;

export const EditForm = S.Struct({
	title: S.String,
	description: S.String,
	tags: S.Array(S.String),
	tagBox: Tags.Model,
	tagError: S.Option(S.String),
	attributes: S.Array(AttributeRow),
	editorFocused: S.Boolean,
	/** The occurred-on instant (KTD1); a picked date keeps the original time-of-day. */
	timestamp: S.String,
});
export type EditForm = typeof EditForm.Type;

export const Model = S.Struct({
	page: S.Literal("Entry"),
	knotId: S.String,
	entry: apiData(Entry).schema,
	/** v1 `useRecordsByIds`: the records that resolved, in `nodeIds` order. */
	linkedRecords: apiData(S.Array(RecordSummary)).schema,
	tab: Tab,
	history: apiData(History).schema,
	/** v1 `HistoryVersionCard` expanded state, by version number. */
	expandedVersions: S.Array(S.Number),
	edit: S.Option(EditForm),
	saving: S.Boolean,
	additionalDataOpen: S.Boolean,
	downloading: S.Boolean,
	downloadError: S.Option(S.String),
});
export type Model = typeof Model.Type;

export const initial = (knotId: string): Model => ({
	page: "Entry",
	knotId,
	entry: AsyncData.Idle(),
	linkedRecords: AsyncData.Idle(),
	tab: "content",
	history: AsyncData.Idle(),
	expandedVersions: [],
	edit: Option.none(),
	saving: false,
	additionalDataOpen: false,
	downloading: false,
	downloadError: Option.none(),
});
